<!--
 * @Author: 孙照
 * @LastEditTime: 2023-10-07 22:23:01
 * @Description: 充电过程数据
 * @FilePath: \fuzhou\src\module\overview\stationChargeModal\components\chargingProcess.vue
-->
<template>
  <div class="charging-process">
    <pub-info-title :title="'充电过程数据'" :is-modal="true" />
    <div class="content">
      <div class="table-title">
        <div class="title-item">启动时间</div>
        <div class="title-item">电站名称</div>
        <div class="title-item">终端编号</div>
        <div class="title-item">停止时间</div>
        <div class="title-item">充电电量</div>
      </div>
      <vue-seamless-scroll
        :data="processLsit"
        :class-option="classOption"
        class="warp"
        >
        <ul class="list">
          <li class="list-item" v-for="(item, index) in processLsit" :key="index">
            <span class="value" v-text="item.startTime"></span>
            <span class="value" v-text="item.stubGroupName"></span>
            <span class="value" v-text="item.stubId"></span>
            <span class="value" v-text="item.endTime"></span>
            <span class="value">{{ item.electric | toNumber }}</span>
            <span class="icon" @click="handleChangeVisible(true,item)">
              <img class="glass" src="@/assets/images/magnifyingGlass.png" alt="">
            </span>
          </li>
        </ul>
      </vue-seamless-scroll>
      <!-- 充电过程弹框 -->
      <charging-progress-modal
        :visible="progressLineChartDialog"
        @change-visible="handleChangeVisible"
        :orderId="orderId"
      />
    </div>
  </div>
</template>

<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
import chargingProgressModal from '@/module/chargingProgressModal/index.vue'; // 充电过程数据弹框

export default {
  name: 'chargingProcess',
  components: {
    pubInfoTitle,
    vueSeamlessScroll,
    chargingProgressModal,
  },
  props: {
    processLsit: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    processLsit: {
      handler(val) {
        console.log(val);
      },
      deep: true,
    },
  },
  data() {
    return {
      progressLineChartDialog: false, // 充电过程数据
      classOption: {
        step: 0.5,
      },
      orderId: '',
    };
  },
  filters:{
    toNumber:(val)=>{
      return val? Number(val).toFixed(0) : "0"
    }
  },  
  methods: {
    handleChangeVisible(flag, item) {
      this.progressLineChartDialog = flag;
      if (item) {
        this.orderId = item.id;
      }
    },
    handleGoCpop() {
      window.open(process.env.VUE_APP_MANAGE);
    }
  },
};
</script>

<style lang="less" scoped>
.charging-process {
  width: 100%;
  .content {
    margin-top: 20px;
    width: 100%;
    .table-title {
      width: 100%;
      height: 30px;
      box-sizing: border-box;
      padding-right: 33px;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      background: rgba(143,204,255,0.09);
      box-shadow: inset 0px 0px 11px 0px rgba(79,179,255,0.54);
      border: 1px solid;
      border-image: linear-gradient(140deg, rgba(136, 230, 255, 1), rgba(143, 204, 255, 1)) 1 1;
      .title-item {
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #C6E8FF;
      }
    }
    .warp {
      width: 470px;
      height: 175px;
      margin: 0 auto;
      overflow: hidden;
      ul {
        width: 100%;
        list-style: none;
        padding: 0;
        margin: 0 auto;
      }
      li {
        list-style-type: none;
      }
      .list{
        .list-item {
          width: 100%;
          height: 30px;
          position: relative;
          box-sizing: border-box;
          padding-right: 33px;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          margin-bottom: 5px;
          background: rgba(10, 50, 89, 0.6);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F5F5F5;
          .value {
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #E7F5FF;
          }
          .icon {
            position: absolute;
            top: 50%;
            right: 20px;
            transform: translateY(-50%);
            cursor: pointer;
            .glass {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
